export default __webpack_public_path__ + "static/media/Yeezy Foam Runner.dc06d592.jpg";